<script>
	import { cuenta } from './../../controlador/store.js';
    import Papel from "../../componentes/papel.svelte";
    import UserController from "../../controlador/userController.svelte";
    import { replace } from 'svelte-spa-router';
    let control;    
    let base64="";
    function base(e){
      base64 = e.detail.data;
    }
    async function guardar(){
        await control.actualizarCuenta($cuenta.nombre,$cuenta.titulo,$cuenta.matricula,base64);
        replace('/cuenta');
    }

  </script>
  <UserController bind:this={control} />
  <div class="container scroll">
    <h2>Cambiar Firma</h2>
    <div class="row">
      <Papel on:base={base}/>
    </div>
    <div class="fila">
      <button on:click={guardar} class="boton"><i class="ph-floppy-disk"></i> Guardar</button>
      <a class="boton" href="#/home"><i class="ph-x-circle"></i> Volver</a>
    </div>
  </div>

  <style>
    h2{
      color: white;
      width: 100%;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .scroll {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
    .boton{
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      color: white;
      margin: 10px;
      padding: 5px;
    }
  </style>